import EquipmentCardsSection from '../modules/equipment-cards';

const sections = document.querySelectorAll('[data-equipment-cards]');
const initEquipmentCards = sections => {
    if (sections) {
        sections.forEach(section => new EquipmentCardsSection(section));
    }
};

initEquipmentCards(sections);
